import React from "react";
import { styles } from "./ProgressBarFilhoStyle";

export default function ProgressBarFilho({ progress }) {
  const percentage = Number(progress?.percentage ?? 0);

  const safePercentage = Math.min(Math.max(percentage, 0), 100);

  const getProgressColor = () => {
    if (safePercentage <= 30) return "var(--danger)";
    if (safePercentage <= 70) return "var(--warning)";
    return "var(--success)";
  };

  return (
    <div style={{ ...styles.containerPrincipal}}>
      <div style={{ ...styles.barraExterna}}>
        <div
          style={{
            ...styles.barraInterna,
            width: `${safePercentage}%`,
            background: getProgressColor(),
          }}
        />

        <div style={styles.textoCentral}>
          {safePercentage.toFixed(2)}%
        </div>
      </div>
    </div>
  );
}